import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-249a41f5")

_pushScopeId("data-v-249a41f5")
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { class: "form-label required" }, "Agent name", -1)
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "form-label required" }, "Personality", -1)
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "form-label required" }, "Goal", -1)
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { class: "form-label required" }, "Additional information", -1)
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Knowledge base", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: null }, "None — personality-only replies", -1)
const _hoisted_12 = { class: "form-text text-muted fs-7 mt-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Optional. When attached, the agent uses this knowledge base for RAG context in replies. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Manage knowledge bases")
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "separator my-6" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("h5", { class: "mb-4" }, "Conversation summary", -1)
const _hoisted_17 = { class: "alert alert-light-primary d-flex align-items-start mb-5" }
const _hoisted_18 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4 mt-1" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "fs-7" }, [
  /*#__PURE__*/_createVNode("strong", null, "Why conversation summaries matter"),
  /*#__PURE__*/_createVNode("p", { class: "mb-0 mt-2" }, [
    /*#__PURE__*/_createTextVNode(" Long DM threads use many AI tokens and can push older context out of the model's window. Summaries are generated every N new messages, and when you re-enable AI after a human handoff. For the next reply, the AI sees "),
    /*#__PURE__*/_createVNode("strong", null, "both"),
    /*#__PURE__*/_createTextVNode(" that summary "),
    /*#__PURE__*/_createVNode("strong", null, "and"),
    /*#__PURE__*/_createTextVNode(" any new messages since the summary was generated — so it keeps full context of recent activity while still remembering earlier parts of the conversation. ")
  ])
], -1)
const _hoisted_20 = { class: "form-check form-switch form-check-custom form-check-solid mb-5" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "summaryEnabled"
}, "Enable conversation summary", -1)
const _hoisted_22 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { class: "form-label required" }, "Summarize every N new messages", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted fs-7 mt-2" }, " A summary runs after this many new messages accumulate since the last summary. A summary also runs when AI is re-enabled from the prospects list after human handoff. ", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "separator my-6" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("h5", { class: "mb-2" }, "Auto Follow-up", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-7 mb-5" }, " Bot will follow up with the contact in the given time sequence. ", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "separator my-6" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("h5", { class: "mb-2" }, "Options", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-7 mb-5" }, " Additional agent behaviors you can enable per agent. ", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "separator my-6" }, null, -1)
const _hoisted_32 = { class: "d-flex justify-content-end gap-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_AiAgentFollowUpPanel = _resolveComponent("AiAgentFollowUpPanel")
  const _component_AiAgentOptionsPanel = _resolveComponent("AiAgentOptionsPanel")

  return (_openBlock(), _createBlock("form", {
    onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
        type: "text",
        class: "form-control form-control-solid",
        placeholder: "e.g. Customer Support Agent",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.form.name]
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.personality = $event)),
        class: "form-control form-control-solid",
        rows: "4",
        placeholder: "Describe who the agent is and how it should behave…",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.form.personality]
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createVNode("textarea", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.goal = $event)),
        class: "form-control form-control-solid",
        rows: "3",
        placeholder: "What should this agent help customers accomplish?",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.form.goal]
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _hoisted_8,
      _withDirectives(_createVNode("textarea", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.additionalInfo = $event)),
        class: "form-control form-control-solid",
        rows: "4",
        placeholder: "Conversation guidelines, boundaries, tone, and other instructions…",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.form.additionalInfo]
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _hoisted_10,
      _withDirectives(_createVNode("select", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.knowledgeBaseId = $event)),
        class: "form-select form-select-solid"
      }, [
        _hoisted_11,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.knowledgeBases, (kb) => {
          return (_openBlock(), _createBlock("option", {
            key: kb.id,
            value: kb.id
          }, _toDisplayString(kb.name), 9, ["value"]))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.form.knowledgeBaseId]
      ]),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_router_link, {
          to: "/settings/ai247-portal?tab=knowledge-bases",
          class: "fw-bold"
        }, {
          default: _withId(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_15,
    _hoisted_16,
    _createVNode("div", _hoisted_17, [
      _createVNode("span", _hoisted_18, [
        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
      ]),
      _hoisted_19
    ]),
    _createVNode("div", _hoisted_20, [
      _withDirectives(_createVNode("input", {
        id: "summaryEnabled",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.summaryEnabled = $event)),
        class: "form-check-input",
        type: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, _ctx.form.summaryEnabled]
      ]),
      _hoisted_21
    ]),
    (_ctx.form.summaryEnabled)
      ? (_openBlock(), _createBlock("div", _hoisted_22, [
          _hoisted_23,
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.summaryMinMessages = $event)),
            type: "number",
            min: "1",
            max: "100",
            class: "form-control form-control-solid w-auto",
            required: ""
          }, null, 512), [
            [
              _vModelText,
              _ctx.form.summaryMinMessages,
              void 0,
              { number: true }
            ]
          ]),
          _hoisted_24
        ]))
      : _createCommentVNode("", true),
    _hoisted_25,
    _hoisted_26,
    _hoisted_27,
    _createVNode(_component_AiAgentFollowUpPanel, {
      modelValue: _ctx.form.followUpScenarios,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.followUpScenarios = $event)),
      "agent-options": _ctx.form.agentOptions,
      "onUpdate:agent-options": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.agentOptions = $event)),
      "agent-id": _ctx.agentId
    }, null, 8, ["modelValue", "agent-options", "agent-id"]),
    _hoisted_28,
    _hoisted_29,
    _hoisted_30,
    _createVNode(_component_AiAgentOptionsPanel, {
      modelValue: _ctx.form.agentOptions,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.agentOptions = $event))
    }, null, 8, ["modelValue"]),
    _hoisted_31,
    _createVNode("div", _hoisted_32, [
      _createVNode("button", {
        type: "button",
        class: "btn btn-light",
        disabled: _ctx.saving,
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('cancel')))
      }, " Cancel ", 8, ["disabled"]),
      _createVNode("button", {
        type: "submit",
        class: "btn btn-primary",
        disabled: _ctx.saving
      }, _toDisplayString(_ctx.saving ? "Saving…" : _ctx.submitLabel), 9, ["disabled"])
    ])
  ], 32))
})